import styled from '@emotion/styled';

export default styled.div`
  width: 120px;
  height: 41px;
  background: url('/logo.png') center no-repeat;
  background-size: cover;
`;
